jQuery(document).ready(function ($) {
	// Close mini cart
	$('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
		closeMini();
	});

	// Show mini cart
	$('.header .icon--cart').on('click', function (e) {
		e.preventDefault();

		if (!$('body').hasClass('template__cart')) {
			Rebuy.SmartCart.show();
		} else {
			e.preventDefault();
		}
	});

	// Mini Cart Remove Product
	$('.mini-cart').on('click', '.remove-product', function () {
		var key = $(this).closest('.product').attr('data-key');
		$(this).closest('.product').addClass('removed');

		removeCartItemByKey(key);
	});

	// Mini Cart Qty
	$('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
		e.preventDefault();

		var $this = $(this);
		var $parent = $this.parent();
		var qtyInput = $parent.find('input');
		var qtyInputVal = qtyInput.val();
		qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
		var lineData = $this.closest('.product').data('lineid');
		var lineNum = $('[data-lineID="' + lineData + '"]').index();
		var key = $(this).closest('.product').attr('data-key');

		if ($this.hasClass('js-qty--plus')) {
			qtyInputVal++;
			qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
		} else {
			qtyInputVal--;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		}

		updateMiniCartItem(key, qtyInputVal);
	});

	// Allow typing of input qty for update
	var timer;
	// $('.mini-cart__list').on('keyup', '.actions .qty-val', function () {
	// 	var $this = $(this);
	// 	var newVal = $this.val();
	// 	var lineData = $this.closest('.product').data('lineid');
	// 	var key = $(this).closest('.product').attr('data-key');

	// 	// clear the previous timer
	// 	clearTimeout(timer);

	// 	// create a new timer with a delay of 300ms seconds,
	// 	// if the keyup is fired before the 300ms secs then the timer will be cleared
	// 	timer = setTimeout(function () {
	// 		// this will be executed if there is a gap of 300ms seconds between 2 keyup events
	// 		console.log(newVal);
	// 		updateMiniCartItem(key, newVal);
	// 	}, 300);
	// });
});

function closeMini() {
	$('body').removeClass('cart-open');
	$('.mini-cart').removeClass('is-open');
	$('.mini-cart').fadeOut('fast');
}

function showMini() {
	if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
		Rebuy.SmartCart.show();
		return;
	}

	$('body').addClass('cart-open');
	$('.mini-cart').fadeIn('fast');
	$('.mini-cart').addClass('is-open');

	// Set height of product list for full-height mini-cart
	// var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
	// var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
	// var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
	// var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
	// var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function openCartDrawer() {
	if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
		Rebuy.SmartCart.show();
		return;
	}

	if (typeof updateMiniCart === 'function') {
		updateMiniCart();
	}
}

function updateMiniCart() {
	jQuery.getJSON('/cart.js', function (cart) {
		refreshMiniCart(cart); // custom function to rebuild the minicart
	});
}

// Update a specific line item (by key or line index)
function updateMiniCartItem(key, quantity) {
	return fetch('/cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({
			id: key, // line number (1-based index) OR item key
			quantity: quantity,
		}),
	})
		.then((response) => response.json())
		.then((cart) => {
			console.log(cart);
			updateMiniCart(cart);
		});
}

function removeCartItemByKey(key) {
	return updateMiniCartItem(key, 0);
}
